import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const styles = {
  collectionList: {
    container: css`
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing(3)};
    `,
    containerMobile: css`
      gap: 0;
    `,
    syncInfo: css`
      margin: 0 var(--fabric-space-padding-md);
    `,
  },
  collectionsSummary: {
    wrapper: css`
      align-items: center;
      display: flex;
      justify-content: space-between;
      width: fit-content;
      border: solid var(--fabric-border-width-thin) var(--fabric-color-neutral-20);
      padding: var(--fabric-space-gap-md);
      border-radius: var(--fabric-radius-md);
    `,
    mobileWrapper: css`
      padding: var(--fabric-space-gap-md);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: var(--fabric-space-gap-md);
      border: solid 1px var(--fabric-color-neutral-20);
      border-radius: var(--fabric-radius-md);
      margin: 0 var(--fabric-space-gap-md);
    `,
    syncedAtText: css`
      align-self: flex-end;
    `,
  },
  filtersOnMobile: {
    container: css`
      display: flex;
      align-items: center;
      gap: var(--fabric-space-gap-md);
      padding: var(--fabric-space-padding-md);
    `,
    dropdownFilter: css`
      width: unset;
      max-width: unset;
    `,
    searchWrapper: css`
      display: flex;
      align-items: center;
      flex: 1;
      > div {
        width: 100%;
      }
    `,
    searchField: css`
      width: 100%;
    `,
    popoverDialog: css`
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing(2)};
      width: 250px;
    `,
    actionButtonsRow: css`
      display: flex;
      justify-content: space-between;
    `,
    applyButton: css`
      width: 100%;
    `,
  },
  filterPanel: {
    checkboxList: css`
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing(1)};
    `,
  },
  topToolbarDesktop: {
    container: css`
      display: flex;
      align-items: center;
      flex: 1;
      gap: ${theme.spacing(2)};
      padding-left: ${theme.spacing(2)};
    `,
    actionsContainer: css`
      display: flex;
      align-items: center;
      flex: 1;
      justify-content: flex-end;
      gap: ${theme.spacing(2)};
    `,
    button: css`
      text-transform: none;
    `,
  },
  topToolbarMobile: {
    container: css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(1)};
      padding: ${theme.spacing(1, 3)};
      border-bottom: 1px solid ${theme.colors.neutral20};
    `,
    selectionActions: css`
      display: flex;
      flex: 1;
      gap: ${theme.spacing(2)};
    `,
    selectionActionsHidden: css`
      visibility: hidden;
    `,
    nakedButton: css`
      cursor: pointer;
      text-decoration: underline;
      color: ${theme.colors.primary50};
    `,
    button: css`
      text-transform: none;
    `,
  },
};
